<template>
  <div>
    <div
    v-for="k in keys" :key="k"
    class="d-flex align-center py-1">
      <v-autocomplete
      v-model="servicesAsObj[k]"
      :label="$t('textFields.selectType')"
      item-text="shortText"
      return-object
      hide-details="auto"
      :items="items"
      solo
      flat
      dense
      class="normal-text-field"
      :disabled="disabled"
      @input="selectService(k)"/>
      <icon-button
      @click="removeService(k)"
      :disabled="disabled"
      src="minus"
      color="#ff3547"/>
    </div>
    <div
    v-if="!noAvaiableItems && !disabled && getCount < max"
    class="d-flex justify-center">
      <icon-button
      @click="addService"
      :disabled="disabled"
      src="plus"
      color="#61c461"/>
    </div>
    <p
    v-if="noAvaiableItems"
    :class="`${noAvaiableItemsLabelColor}--text font-weight-medium`">
      {{$t(noAvaiableItemsLabel)}}
    </p>
  </div>
</template>

<script>
import IconButton from '@/components/btns/IconButton'
import { v4 as uuidGenerate } from 'uuid'
import { copyObj } from '@/utils/StringUtil'
export default {
  components: {
    IconButton
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 5
    },
    noAvaiableItemsLabel: {
      type: String,
      default: null
    },
    noAvaiableItemsLabelColor: {
      type: String,
      default: "red"
    }
  },
  model: {
    prop: "value",
    event: "valueChanged"
  },
  data() {
    return {
      servicesAsObj: {},
      keys: [],
    }
  },
  computed: {
    model: {
      get: function() {
        return this.$props.value
      },
      set: function(v) {
        this.$emit("valueChanged", v)
      }
    },
    getCount() {
      return this.keys.length
    },
    noAvaiableItems() {
      return this.items.length === 0
    }
  },
  methods: {
    addService() {
      const k = `service_${uuidGenerate()}`
      this.servicesAsObj[k] = null
      this.keys.push(k)
    },
    removeService(k) {
      delete this.servicesAsObj[k]
      this.keys = this.keys.filter(o => o !== k)
      const filtered = this.model.filter(o => o.objId !== k)
      this.model = filtered

      this.emitModelChanged(filtered)
    },
    selectService(k) {
      const filtered = this.model.filter(o => o.objId === k)
      if (filtered.length > 0) {
        // NOTE: Only the items coming from the BE have id, the new one must not
        delete filtered[0].id
        filtered[0].text = this.servicesAsObj[k].text
        filtered[0].shortText = this.servicesAsObj[k].shortText
        filtered[0].value = this.servicesAsObj[k].value
        return
      }
      
      const o = this.servicesAsObj[k]
      this.model.push({
        objId: k,
        text: o.text,
        shortText: o.shortText,
        value: o.value
      })

      this.emitModelChanged(this.model)
    },
    emitModelChanged(arr) {
      this.$emit("changed", arr)
    }
  },
  mounted() {
    for (let i = 0; i < this.model.length; i++) {
      const k = `service_${uuidGenerate()}`
      const s = this.model[i]
      s.objId = k
      this.servicesAsObj[k] = copyObj(s)
      this.keys.push(k)
    }
  }
}
</script>

<style>

</style>